"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "fetchOrders", {
    enumerable: true,
    get: ()=>fetchOrders
});
const _graphqlRequest = require("graphql-request");
const _orderFragment = require("../fragments/order-fragment");
const fetchOrders = (0, _graphqlRequest.gql)`
    query FetchOrders(
        $retailerId: ID!
        $customerId: ID!
    ) {
        orders(
            retailerId: $retailerId
            filter: { customerId: $customerId }
        ) {
            ...orderFragment
        }
    }
    ${_orderFragment.ORDER_FRAGMENT}
`;
